import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { products as mockProducts } from "@/mocks/home";

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:4001";

// Hàm map mã ngôn ngữ từ client i18n sang mã locale chuẩn của Backend
const mapLocaleForApi = (lng: string): string => {
  if (lng === "zh-Hant") return "zh-TW";
  if (lng === "zh") return "zh-CN";
  return lng || "en";
};

export function useHomeCategories() {
  const { i18n } = useTranslation();
  const currentLocale = mapLocaleForApi(i18n.language);

  const { data: catRes, isLoading } = useQuery({
    queryKey: ["home-categories", currentLocale],
    queryFn: async () => {
      // Tự động truyền query param ?locale=... theo ngôn ngữ đang chọn
      const res = await axios.get(`${API_URL}/api/categories`, {
        params: { locale: currentLocale },
      });
      return res.data;
    },
    staleTime: 1000 * 60 * 5, // Cache dữ liệu trong 5 phút
  });

  const rawCategories = catRes?.data?.items || catRes?.data || [];

  // Map dữ liệu và chuẩn bị fallback hình ảnh
  const categories = rawCategories.slice(0, 4).map((c: any, index: number) => ({
    id: c.id,
    name: c.name || "Unnamed Category", // Đã được Backend fallback tự động sang EN nếu thiếu bản dịch
    desc: c.description || "Vietnamese export rice category",
    img: c.imageUrl
      ? `${API_URL}${c.imageUrl}`
      : mockProducts[index % mockProducts.length]?.img,
  }));

  return {
    categories,
    isLoading,
    hasData: categories.length > 0,
  };
}
